import styled from 'styled-components';

export const InputTextAcessibilidade = styled.p`
  background-color: #f5f5f5;
  margin-bottom: 0;
  position: relative;
  border-radius: 0.5rem;
  height: 50px;
  padding: 10px 12px;
  width: 100%;
  font-size: 11pt;
  border: solid 1px #d9d9d9;
  color: var(--input-color-disabled) !important;
  cursor: not-allowed;
`;
